import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { XStackContainer } from "../../Containers";
import { ObjectDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { PieChartFormControl } from "../Web/PieChartFormControl";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: PieChartFormControl } {
    let ui = new FormConfiguration();
    let dataDef = ui.getInputDefinition();

    const chartDataDef = new ObjectDataDefinition("invoiceByMonth");
    chartDataDef.list = true;
    const labelDef = new StringDataDefinition("label");
    const valueDef = new NumberDataDefinition("value");
    chartDataDef.fields.push(labelDef);
    chartDataDef.fields.push(valueDef);
    dataDef.fields.push(chartDataDef);

    const values = [
        {
            label: "Jan",
            value: 1600,
            color: "black",
            radius: 140,
        },
        {
            label: "Feb",
            value: 1450,
            color: "lightgreen",
            radius: 170,
        },
        {
            label: "Mar",
            value: 1700,
            color: "lightblue",
            radius: 130,
        },
        {
            label: "Apr",
            value: 1500,
            color: "blue",
            radius: 100,
        },
        {
            label: "May",
            value: 1350,
            color: "purple",
            radius: 80,
        },
        {
            label: "Jun",
            value: 1900,
            color: "red",
            radius: 240,
        },
        {
            label: "Jul",
            value: 2000,
            color: "green",
            radius: 200,
        },
        {
            label: "Aug",
            value: 1750,
            color: "pink",
            radius: 160,
        },
        {
            label: "Sep",
            value: 1300,
            color: "orange",
            radius: 80,
        },
        {
            label: "Oct",
            value: 1800,
            color: "yellow",
            radius: 140,
        },
        {
            label: "Nov",
            value: 1850,
            color: "gray",
            radius: 150,
        },
        {
            label: "Dec",
            value: 1650,
            color: "green",
            radius: 100,
        },
    ];

    dataDef.value["invoiceByMonth"] = values;

    ui.inputData = dataDef;

    let container = new XStackContainer();
    const chart = new PieChartFormControl();
    container.add(chart);
    ui.add(container);

    return { form: ui, control: chart };
}

export const PieChartStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Pie Chart",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Donut Chart";
            ui.control.isDonut = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Pie Chart",
        "Donut",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Donut Chart with Custom inner Radius";
            ui.control.isDonut = true;
            ui.control.innerRadius = 60;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Pie Chart",
        "Donut (inner radius)",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Custom Color Pie Chart";
            ui.control.colorType = "Custom";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Pie Chart",
        "Donut (custom color)",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Pie Chart with Legend";
            ui.control.legendPosition = "bottom";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Pie Chart",
        "With legend",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Pie Chart with custom radius";
            ui.control.customRadius = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Pie Chart",
        "Custom Radius",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Pie Chart without label";
            ui.control.showLabel = false;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Pie Chart",
        "Hide Label",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Pie Chart without tooltip";
            ui.control.showToolTip = false;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Pie Chart",
        "Hide Tooltip",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Pie Chart shows in 3D";
            ui.control.show3D = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Pie Chart",
        "3d",
    ),
];
